const constants = {
    MIN_FORWARD_LINE_COUNT: 2,
    MIN_DEFENCE_LINE_COUNT: 2,
    MIN_GOALIE_LINE_COUNT: 1,

    MAX_FORWARD_LINE_COUNT: 6,
    MAX_DEFENCE_LINE_COUNT: 5,
    MAX_GOALIE_LINE_COUNT: 3,

    REQUIRED_FORWARD_LINE_PLAYER_COUNT: 3,
    REQUIRED_DEFENSE_LINE_PLAYER_COUNT: 2,
    REQUIRED_GOALIE_LINE_PLAYER_COUNT: 1,

    DEFAULT_FORWARD_ROW_COUNT: 4,
    DEFAULT_DEFENSE_ROW_COUNT: 3,
    DEFAULT_GOALIE_ROW_COUNT: 2,

    MAX_TWEET_LENGTH: 280,

    PRESS_ROOM_CMP: -2,

    EULA_NEEDS_APPROVAL: 'EULA_NEEDS_APPROVAL',

    APP_VERSION: "1.0.2",

    DEFAULT_PUBLISHER_NAME: "1Rink",

    GOALIE_CODE: 'G'
}

export default constants;
